"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBQm", {
  enumerable: true,
  get: function get() {
    return _services.default;
  }
});
var _services = _interopRequireDefault(require("./components/services"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }